import React, { useState, useEffect } from 'react';
import { hot } from 'react-hot-loader/root';
import useLanguage from 'hooks/useLanguage';

import bakerLogoImg from '../images/BKRlogo.png';
import '../css/pc/baker-header.css';

const BakerHeader = () => {
  const { lang } = useLanguage();

  const showAlert = () => {
    alert(lang.navbar.alert_tip);
    return;
  };

  return (
    <div className="baker-header">
      <div className="baker-header-left">
        <img src={bakerLogoImg} />
        <p>{lang.app_name}</p>
      </div>
      <div className="baker-header-right">
        <a href="https://www.bakerfi.com/" target="_blank">
          {lang.navbar.home}
        </a>
        <a href="https://www.bakerfi.com/#/farmingv2" target="_blank">
          {lang.navbar.mine}
        </a>
        <a onClick={showAlert}>{lang.navbar.govern}</a>
        <a
          href="https://github.com/BakerDAO-Fi/docs/blob/main/deployments/bsc_mainnet_addresses.json"
          target="_blank"
        >
          {lang.navbar.contract}
        </a>
        <a
          href="https://www.bakerfi.com/docs/BakerDAO-Audit-Report-CertiK.pdf"
          target="_blank"
        >
          {lang.navbar.contract_audit}
        </a>
        {/* <a onClick={showAlert}>{lang.navbar.mine_contract_audit}</a> */}
        <a href="https://bakerdao.gitbook.io/" target="_blank">
          {lang.navbar.api}
        </a>
        <a
          href="https://bscscan.com/token/0xD39b64FA868f5c0b505bce73FB416F5aa442A8c9"
          target="_blank"
        >
          {lang.navbar.hai}
        </a>
        <a
          href="https://bscscan.com/token/0x6636F7B89f64202208f608DEFFa71293EEF7b466"
          target="_blank"
        >
          {lang.navbar.hkr}
        </a>
      </div>
    </div>
  );
};

export default hot(BakerHeader);
